var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMembershipSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.000488281,
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_3151_4779)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.501 20.0017C30.501 25.5246 26.0238 30.0017 20.501 30.0017C14.9781 30.0017 10.501 25.5246 10.501 20.0017C10.501 14.4789 14.9781 10.0017 20.501 10.0017C26.0238 10.0017 30.501 14.4789 30.501 20.0017ZM15.001 20.0017C15.001 23.0393 17.4634 25.5017 20.501 25.5017C23.5385 25.5017 26.001 23.0393 26.001 20.0017C26.001 16.9641 23.5385 14.5017 20.501 14.5017C17.4634 14.5017 15.001 16.9641 15.001 20.0017Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3151_4779",
    x1: 20.5,
    y1: 0.000488281,
    x2: 20.5,
    y2: 40.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EF7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7EF7D",
    stopOpacity: 0.41
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMembershipSelected);
export default __webpack_public_path__ + "static/media/iconMembership_Selected.05e9f4f055ccb592b90bc8b0cd4411f0.svg";
export { ForwardRef as ReactComponent };